export const DASHBOARD_ACTIONS = {
	SIDEBAR: 'sidebar',
	POPUP: 'popup',
	ADD_NODE: 'addNode',
	EDGE_CONNECTION: "edgeConnection"
}
